import React from 'react';
import { useTranslation } from 'react-i18next';
import { QRCodeSVG } from 'qrcode.react';

interface MfaQrDisplayProps {
  otpAuthUri: string;
  secret: string;
}

export const MfaQrDisplay: React.FC<MfaQrDisplayProps> = ({ otpAuthUri, secret }) => {
  const { t } = useTranslation('mfa');
  const groups = secret.match(/.{1,4}/g)?.join(' ') ?? secret;

  return (
    <div className="flex flex-col items-center space-y-4">
      <div className="bg-white p-4 rounded-lg">
        <QRCodeSVG value={otpAuthUri} size={200} level="M" includeMargin={false} />
      </div>
      <div className="text-center">
        <p className="text-sm text-muted-foreground mb-1">
          {t('qrDisplay.manualEntryHint')}
        </p>
        <code className="text-sm font-mono bg-muted px-3 py-1.5 rounded border break-all">
          {groups}
        </code>
      </div>
    </div>
  );
};
